import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import HeaderWrapper from "../common/HeaderWrapper";

import CallService from "../../services/callService";

const useFetch = (range, userId, departmentId, onFetchCalls) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await CallService.fetchAggregateHours({
        assigned_to: userId,
        startDate: range.start,
        endDate: range.end,
        department: departmentId
      });
      setData(result);
      onFetchCalls(result?.length);
    };
    fetchData();
  }, [departmentId, range.end, range.start, userId, onFetchCalls]);
  return { data };
};

const colors = [
  "#424874",
  "#50accb",
  "#3cc4ec",
  "#35d687",
  "#d8dbe2",
  "#ffcd3f",
  "#fe703f",
  "#4c53d6"
];
const DashboardAggregateHours = ({
  history,
  auth,
  userId,
  departmentId,
  range,
  onFetchCalls,
  dragState
}) => {
  const { data: aggregateHours } = useFetch(
    range,
    userId,
    departmentId,
    onFetchCalls
  );
  const totalHours = aggregateHours.reduce(
    (acc, curr) => curr.totalHours + acc,
    0
  );
  const vizTotalHours = Math.max(
    ...aggregateHours.map(({ totalHours: th }) => th)
  );

  const onCallClick = (item) => {
    if (!dragState.dragInProcess && dragState.dragOver) {
      history.push(`/app/projects/${item.id}`);
    }
  };

  return (
    <React.Fragment>
      <HeaderWrapper breadcrumbs={[{ label: `Call Breakdown` }]} />
      <div className="content-wrapper">
        <div
          className={`aggregate-container ${
            auth.isNightMode ? "is-night-mode" : ""
          }`}
        >
          {aggregateHours.map((item, i) => (
            <div
              key={`dash-agg-item-${i}`}
              className="aggregate-item"
              role="presentation"
              onKeyDown={() => {}}
              onClick={() => onCallClick(item)}
            >
              <p>
                {item.project}
                <br />
                <small>{item.customer}</small>
              </p>
              <div
                style={{
                  flexBasis: `${(item.totalHours / vizTotalHours) * 100}%`,
                  height: 35,
                  background: colors[i % colors.length]
                }}
              >
                <span className="hover-display">{item.totalHours} hrs</span>
                <span>
                  {(item.totalHours
                    ? (item.totalHours / totalHours) * 100
                    : 0
                  ).toFixed(1)}
                  %
                </span>
              </div>
            </div>
          ))}
        </div>
        {/* <pre>
        <code>{JSON.stringify(aggregateHours, null, 2)}</code>
      </pre> */}
      </div>
    </React.Fragment>
  );
};

DashboardAggregateHours.propTypes = {
  history: PropTypes.object,
  auth: PropTypes.object,
  range: PropTypes.object,
  userId: PropTypes.string,
  departmentId: PropTypes.string,
  onFetchCalls: PropTypes.func,
  dragState: PropTypes.object
};
DashboardAggregateHours.defaultProps = {
  range: {},
  onFetchCalls: () => null,
  dragState: {}
};
export default DashboardAggregateHours;
